import React, { useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import styles from "./RadioButtonInput.module.css";

const RadioButtonInput = ({
  name,
  simpleQuestionValue,
  setSelectionState,
  initialValue,
  labelYes = null,
  labelNo = null,
  isError,
}) => {
  const [selection, setSelection] = useState("");

  const handleRadioChange = (value) => {
    switch (value) {
      case "da":
        setSelectionState(true);
        sessionStorage.setItem(name, "da");
        break;
      case "ne":
        setSelectionState(false);
        sessionStorage.setItem(name, "ne");
        break;
      default:
        break;
    }
    setSelection(value);
  };

  useEffect(() => {
    let savedValue = sessionStorage.getItem(name);

    if (savedValue) {
      setSelection(savedValue);
      if (savedValue === "da") {
        setSelectionState(true);
      } else if (savedValue === "ne") {
        setSelectionState(false);
      }
    } else if (initialValue !== undefined) {
      if (initialValue === true) {
        setSelection("da");
        setSelectionState(true);
      } else if (initialValue === false) {
        setSelection("ne");
        setSelectionState(false);
      }
    }
  }, [initialValue, name, setSelectionState]);

  return (
    <div className={styles.radioButtonContainer}>
      <p className={styles.simpleQuestionText}>{simpleQuestionValue}</p>
      {isError && <p className={styles.errorText}>Ovo polje je obavezno</p>}
      <Form>
        <Form.Check
          type="radio"
          id="default-radio-da"
          label={labelYes || 'Da'} 
          value="da"
          name="radioGroup"
          checked={selection === "da"}
          onChange={() => handleRadioChange("da")}
        />
        <Form.Check
          type="radio"
          id="default-radio-ne"
          label={labelNo || 'Ne'}
          value="ne"
          name="radioGroup"
          checked={selection === "ne"}
          onChange={() => handleRadioChange("ne")}
        />
      </Form>
    </div>
  );
};

export default RadioButtonInput;
